import { render, staticRenderFns } from "./FormSelect.vue?vue&type=template&id=7ec4c10f&scoped=true"
import script from "./FormSelect.vue?vue&type=script&lang=ts"
export * from "./FormSelect.vue?vue&type=script&lang=ts"
import style0 from "./FormSelect.vue?vue&type=style&index=0&id=7ec4c10f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec4c10f",
  null
  
)

export default component.exports